import type { ReactNode } from 'react';
import { cn } from '../foundation/cn';

export interface EmptyStateProps {
  readonly title: string;
  readonly description?: string | undefined;
  readonly icon?: ReactNode;
  readonly action?: ReactNode;
  readonly className?: string;
}

export function EmptyState({
  title,
  description,
  icon,
  action,
  className,
}: EmptyStateProps): JSX.Element {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 p-8 text-center text-fg-muted',
        className,
      )}
    >
      {icon !== undefined && <div className="text-3xl">{icon}</div>}
      <p className="font-medium text-fg">{title}</p>
      {description !== undefined && <p className="text-sm">{description}</p>}
      {action !== undefined && <div className="mt-2">{action}</div>}
    </div>
  );
}
